/*import React, {useState, useEffect} from 'react';*/
import { useNavigate } from 'react-router-dom'
import './Projects.css';
import tpscover from '../assets/images/futuraTPScover.png';
import sonosHero from "../assets/images/sonosHero.png";
import mfpCover from "../assets/images/mfpCover.png";




export default function Projects() {
    const navigate = useNavigate();

    const goToProject = (projectPath) => {
        navigate(projectPath);
};


    return (
        <div className='project-container'>
            <div className="title">
                <h1>Projects</h1>
            </div>
            <div className="projects-grid">

            {/*<div className="project-card">
            <div className="project-img-container">
                    <img src={ftHero} alt='Food Tracker App' className='project-img' />
                </div>
                <div className="project-info">
                    <h3>Food Tracker App</h3>
                    <p>Google UX Design Certificate</p>
                    <button className="view-button" onClick={() => goToProject('/projects/food-tracker')}>View Project</button>
                </div>
            </div> */}

            <div className="project-card">
            <div className="project-img-container">
                    <img src={tpscover} alt='ASU TPS App' className='project-img' />
                </div>
                <div className="project-info">
                    <h3>Type Specimen Persona App</h3>
                    <p>UX Design · Figma</p>
                    <button className="view-button" onClick={() => goToProject('/projects/type-specimen')}>View Case Study</button>
                </div>
            </div>

            <div className="project-card">
            <div className="project-img-container">
                    <img src={mfpCover} alt='myfitnesspal journey map' className='project-img' />
                </div>
                <div className="project-info">
                    <h3>Journey Map Report</h3>
                    <p>UX Research · Figma</p>
                    <button className="view-button" onClick={() => goToProject('/projects/journey-map-report')}>View Case Study</button>
                </div>
            </div>

            <div className="project-card">
            <div className="project-img-container">
                    <img src={sonosHero} alt='Sonos App Redesign' className='project-img' />
                </div>
                <div className="project-info">
                    <h3>Sonos App Redesign</h3>
                    <p>UX Design · Figma</p>
                    <button className="view-button" onClick={() => goToProject('/projects/sonos-app')}>View Case Study</button>
                </div>
            </div>

<div className="project-card">
                <div className="project-img-container">
                    <img src="/images/cani-main-hero.png" alt="CANI Dual Website Launch" className="project-img" />
                </div>
                <div className="project-info">
                    <h3>CANI — Dual Website Launch</h3>
                    <p>Web Design · HubSpot · WordPress</p>
                    <button className="view-button" onClick={() => goToProject('/projects/cani')}>View Case Study</button>
                </div>
            </div>

            <div className="project-card">
                <div className="project-img-container">
                    <img src="/images/helpusserve-hero.png" alt="Help Us Serve Nonprofit UX" className="project-img" />
                </div>
                <div className="project-info">
                    <h3>Help Us Serve — Nonprofit UX</h3>
                    <p>UX Design · WordPress · Donation Platform</p>
                    <button className="view-button" onClick={() => goToProject('/projects/help-us-serve')}>View Case Study</button>
                </div>
            </div>

            <div className="project-card">
                <div className="project-img-container">
                    <img src="/images/studio907cover.png" alt="Studio 907 Web Design" className="project-img" />
                </div>
                <div className="project-info">
                    <h3>Studio 907 — Web Design &amp; Branding</h3>
                    <p>Web Design · Branding · Framer</p>
                    <a href="https://studio907.io" target="_blank" rel="noopener noreferrer" className="view-button">Visit Site →</a>
                </div>
            </div>

      </div>

    </div>
    );
}